import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";
import ChecklistCard from "./ChecklistCard";

export default function BCMustRefer() {
  const ReferralDocs = [
    "Referral Agreement",
    "Disclosure of Referral Payment to be Received",
  ];

  return (
    <>
      <div className="clause-card-content bc-must-refer-warning-wrap">
        <div className="clause-warning">
          <div className="clause-warning-icon">
            <FontAwesomeIcon icon={faTriangleExclamation} size="lg" />
          </div>
          <div>
            The Real Estate Act prohibits dual agency, so you cannot act on
            behalf of both clients in the same transaction. Depending on the
            situation, you may need to release one or both clients.
          </div>
        </div>
      </div>

      <ChecklistCard
        CheckListData={[
          "Agreement Regarding Conflict of Interest Between Clients (Resulting in Releasing/Referring One or Both Clients)",
        ]}
        CheckListData2={ReferralDocs}
        Header={"Client Referral"}
        Title1="Already Represent Both Clients"
        Title2="Referral Documents"
        province="BC"
      />
    </>
  );
}

/*


CheckListData2={ReferralDocs}
        CheckListData={["Added to Deal Sheet"]}
        Header={"Referral"}
        Title2="Referral Documents (Outside Brokerage Listing)"
        Title1="Referral Documents (eXp Listing)"
        province="AB"

*/
